import type { ValidationCheck } from "@/config/contentProgramUpload";
import { cn } from "@/lib/utils";

/** Each requirement as a dot and a word, the way status reads everywhere else. */
export default function ValidationFeedback({ checks, validating }: { checks: ValidationCheck[]; validating?: boolean }) {
  if (validating) {
    return (
      <div className="space-y-2 animate-pulse">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex items-center justify-between border-t border-border py-2.5 first:border-t-0">
            <div className="h-3.5 w-24 rounded bg-muted" />
            <div className="h-3.5 w-16 rounded bg-muted" />
          </div>
        ))}
      </div>
    );
  }
  if (!checks.length) return null;

  return (
    <div>
      {checks.map((check) => (
        <div
          key={check.key}
          className="flex items-baseline justify-between gap-4 border-t border-border py-2.5 text-sm first:border-t-0"
        >
          <span className="inline-flex shrink-0 items-center gap-1.5 text-foreground">
            <span
              aria-hidden
              className={cn(
                "size-1.5 rounded-full",
                check.status === "pass" && "bg-emerald-500",
                check.status === "fail" && "bg-red-500",
                check.status === "pending" && "bg-muted-foreground/60"
              )}
            />
            {check.label}
          </span>
          <span className={cn("min-w-0 truncate text-right tabular-nums", check.status === "fail" ? "text-destructive" : "text-muted-foreground")}>
            {check.detail ?? (check.status === "pass" ? "Ok" : "")}
          </span>
        </div>
      ))}
    </div>
  );
}
